import { useContext } from "react"
import { AppContext } from "../App"

export default function MarketplaceSection({ title, items, itemComponent: ItemComponent, moreItem, moreLabel }) {

  const appContext = useContext(AppContext);

  return (
    <section className="marketplace-section">
      <div className="d-flex justify-content-between align-items-center gap-3 mb-4">
        <h6 className="marketplace-section-title m-0">{title}</h6>
        <button
          className="btn btn-sm btn-outline-primary btn-rounded flex-shrink-0"
          onClick={() => appContext.navTo({ item: moreItem })}
        >
          {moreLabel}
        </button>
      </div>

      <div className="row g-4">
        {
          items.length > 0 ?
            items.map((item) => {
              return (
                <div className="col-12 col-sm-6 col-lg-4" key={item.uuid}>
                  <ItemComponent data={item} />
                </div>
              )
            })
            :
            <div className="col-12">
              <div className="marketplace-empty-state">No content was found</div>
            </div>
        }
      </div>
    </section>
  )
}
